import * as Yup from 'yup';
import {yupStringMin} from '../../../../functions/validationsYup';

export const getPricingGroupValidationSchema = (globalT: (key: string) => string) => {
    return Yup.object().shape({
        name: yupStringMin().required(globalT('errorRequired')),
        startPrice: Yup.number().positive(globalT('errorNumber')).required(globalT('errorRequired')),
        endPrice: Yup.number().positive(globalT('errorNumber')).required(globalT('errorRequired')),
    });
};

